export const LIST = "TRANSACTION_LISTING";
export const DROPDOWN = "TRANSACTION_DROPDOWN";
export const DETAILS = "TRANSACTION_DETAILS";
export const NOTIFICATION = "TRANSACTION_BELL_RING_NOTIFICATION";
